/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForSecurityHub extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForSecurityHub.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForSecurityHub>): ProgressDetailsForSecurityHub {
        let obj = Object.assign(new ProgressDetailsForSecurityHub(), model);
        ProgressDetailsForSecurityHub.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForSecurityHub>): ProgressDetailsForSecurityHub {
        if (!model) return null;
        return ProgressDetailsForSecurityHub.newInstance(<ProgressDetailsForSecurityHub> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForSecurityHub) {
        if (!obj) return;

        models.ProgressDetailsForSecurityHub.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForSecurityHub): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForSecurityHub.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.by_location) {
            for (let val of this.by_location) {
                models.ProgressDetailsMessagePerLocation.fixupPrototype(val);
            }
        }
    }

    by_location: Array<models.ProgressDetailsMessagePerLocation>;

}
